import React, { createContext, useContext, useState } from 'react';
import useMicrophonePermission from '../hooks/useMicrophonePermission';

const VoiceContext = createContext(null);

export function VoiceProvider({ children }) {
  const { supported, granted, requestPermission } = useMicrophonePermission();
  const [voiceWarningDismissed, setVoiceWarningDismissed] = useState(false);

  // Determine final permission state
  const microphoneGranted = granted === true;
  const microphoneSupported = supported;

  const value = {
    microphoneGranted,
    microphoneSupported,
    voiceWarningDismissed,
    setVoiceWarningDismissed,
    requestPermission,
  };

  return (
    <VoiceContext.Provider value={value}>
      {children}
    </VoiceContext.Provider>
  );
}

export function useVoice() {
  const context = useContext(VoiceContext);
  if (!context) {
    throw new Error('useVoice must be used within VoiceProvider');
  }
  return context;
}
